import React from 'react';

const PencilIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.3335 15.2921C1.1678 15.2918 1.00896 15.2259 0.891798 15.1088C0.774635 14.9916 0.708717 14.8327 0.708496 14.6671V11.1829C0.709096 11.0173 0.774971 10.8586 0.891829 10.7412L10.2593 1.37539C10.4698 1.16474 10.7198 0.997638 10.9949 0.883628C11.27 0.769619 11.5649 0.710937 11.8627 0.710938C12.1605 0.710937 12.4553 0.769619 12.7304 0.883628C13.0056 0.997638 13.2555 1.16474 13.466 1.37539L14.6252 2.53455C14.8358 2.74505 15.0029 2.995 15.1169 3.27011C15.2309 3.54521 15.2896 3.84009 15.2896 4.13789C15.2896 4.43568 15.2309 4.73056 15.1169 5.00567C15.0029 5.28077 14.8358 5.53072 14.6252 5.74122L5.26016 15.1087C5.20217 15.167 5.1332 15.2132 5.05725 15.2446C4.9813 15.2761 4.89987 15.2922 4.81766 15.2921H1.3335ZM1.9585 11.4412V14.0421H4.5585L11.1502 7.45039L8.55016 4.85039L1.9585 11.4412ZM12.0343 6.56705L13.7435 4.85789C13.934 4.66684 14.0409 4.40808 14.0409 4.1383C14.0409 3.86853 13.934 3.60976 13.7435 3.41872L12.5827 2.25705C12.3917 2.06638 12.1329 1.95928 11.8631 1.95928C11.5932 1.95928 11.3344 2.06638 11.1435 2.25705L9.4335 3.96705L12.0343 6.56705Z"
      fill="currentColor"
    />
  </svg>
);

export default PencilIcon;
